// extracted by mini-css-extract-plugin
module.exports = {"menu":"LayoutDropDown_menu__18TTw","menu-item":"LayoutDropDown_menu-item__1szQp","img-div":"LayoutDropDown_img-div__T-BSt"};